var _circle, _circle2, _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainSectionLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86,
    r: 86,
    fill: "white",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.0009,
    cy: 86.0009,
    r: 72.9697,
    fill: "white",
    fillOpacity: 0.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.90636,
    cy: 7.93159,
    rx: 7.90636,
    ry: 7.93159,
    transform: "matrix(-1 0 0 1 114.98 77.7773)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.0942 53.2105C86.9814 51.1622 90.0532 51.1622 91.9404 53.2105C93.8136 55.2435 93.8136 58.5294 91.9404 60.5624L68.314 86.205L91.9404 111.848C93.8136 113.881 93.8136 117.167 91.9404 119.2C90.0532 121.248 86.9814 121.248 85.0942 119.2L58.0808 89.881C56.2076 87.848 56.2076 84.562 58.0808 82.529L85.0942 53.2105Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.651515,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainSectionLeftArrow);
export default __webpack_public_path__ + "static/media/MainSectionLeftArrow.4b4a09eb7ee9e98856a29e444c193d75.svg";
export { ForwardRef as ReactComponent };